// Use the carousel's width so product rows also fit narrow page columns.
export const bookCarouselBreakpoints = {
  0: { slidesPerView: 1, spaceBetween: 12 },
  300: { slidesPerView: 2, spaceBetween: 10 },
  540: { slidesPerView: 3, spaceBetween: 14 },
  760: { slidesPerView: 4, spaceBetween: 16 },
  1020: { slidesPerView: 5, spaceBetween: 18 },
  1280: { slidesPerView: 6, spaceBetween: 20 },
};

// Lazy images can finish loading after Swiper measures the active slide.
export const updateBannerHeight = (event) => {
  const swiper = event.currentTarget.closest('.swiper')?.swiper;
  if (swiper && !swiper.destroyed) swiper.updateAutoHeight();
};
